import { isRemoteCell, type Cell } from "./cells";

/**
 * The management (Harmony IT) tenant of a cell, which management-only
 * endpoints expect as `tenant_id`. The primary cell's comes from the build
 * env; another cell's is the tenant its admins sign in to, which is the same
 * tenant that cell's services are configured as management for.
 */
export function managementTenantId(cell: Cell): string | undefined {
  if (isRemoteCell(cell)) {
    return cell.remote.descopeTenantId;
  }
  return (
    import.meta.env.VITE_FORCE_TENANT_ID ||
    (import.meta.env.VITE_HARMONY_TENANT_ID as string | undefined)
  );
}
